import { monthDay } from './rank';

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// '1913-08-04' -> '4 Aug 1913'
export function formatDate(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso || '';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!m) return String(y);
  return `${d ? `${d} ` : ''}${MONTHS[m - 1]} ${y}`;
}

// '14-1-1946' (D-M-YYYY) -> '1946-01-14'
export function dmyToIso(dmy) {
  const m = /^(\d{1,2})-(\d{1,2})-(\d{4})$/.exec((dmy || '').trim());
  if (!m) return null;
  return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
}

export const hasDevanagari = (s) => /[ऀ-ॿ]/.test(s || '');

const hash = (str) => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

/**
 * Items whose date falls on today's month/day, plus `n` others that rotate
 * daily. Keeps large sources (letters, audio) from flooding the feed.
 */
export function pickForToday(list, n, { now, key, date }) {
  const md = monthDay(now);
  const day = now.toISOString().slice(0, 10);
  const onThisDay = list.filter((x) => (date(x) || '').slice(5, 10) === md);
  const rest = list
    .filter((x) => !onThisDay.includes(x))
    .map((x) => [hash(`${day}:${key(x)}`), x])
    .sort((a, b) => a[0] - b[0])
    .slice(0, n)
    .map(([, x]) => x);
  return [...onThisDay, ...rest];
}

// Cache a promise for the whole session (data files rarely change).
export function once(fn) {
  let p = null;
  return () => {
    if (!p) {
      p = fn().catch((e) => {
        p = null;
        throw e;
      });
    }
    return p;
  };
}

// Shared with the Cloud Functions.
export { toAppPath } from './shared/links.js';
